module.exports = __webpack_public_path__ + "media/img/about/main-banner-mobile-a9eca760cf966cefc774a7d5a3838f35.png";